module.exports = __webpack_public_path__ + "img/premium_bodyimage04.d10185f9.jpg";